module.exports = Object.freeze({
  STRING: "string",
  MILLISECONDS: "milliseconds",
  TEMPERATURE: "temperature",
  TEMPERATURE_RANGE: "temperature_range",
});
